var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"component-body"},[_vm._v(_vm._s(_vm._f("pluralized")(_vm.indicator)))])
}
var staticRenderFns = []

export { render, staticRenderFns }